import React, { Component } from 'react';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import styled from 'styled-components'
import cssVar from '../../styles/variables'
import { withRouter } from "react-router-dom";
import { MaxContentWidthWrapper, MaxContentWidthContainer, Text } from '../marketing/MarketingStyles';
import { withCookies, Cookies } from 'react-cookie';

import { Arrow } from '../../images/icons/Icons';

import { trackEvent } from "../../utils/eventTracking"



const AVAILABLE_LANGUAGES = [ { name: 'DE', code: 'de' }, { name: 'EN', code: 'en' }, { name: 'IT', code: 'it' } ]

@inject('userStore', 'utilStore', 'modalStore', 'translationStore')
@observer
class MarketingHeader extends Component {

  constructor( props ) {
    super(props)

    this.state = {
      mobileNavigationOpen: false
    }
  }

  toggleMobileNavigation = () => {
    this.setState({ mobileNavigationOpen: !this.state.mobileNavigationOpen })
  }

  openMobileLink = (target) => {
    this.props.history.push(target)
    this.setState({ mobileNavigationOpen: false })
  }

  openRequestInformationModal = () => {
    this.props.modalStore.setState('request_information', true)
    trackEvent( 'Request Information - "Mehr Informationen" - CTA Section', 'Advertisment', 'Click Button' )
  }

  render() {

    const { isLoggedIn } = this.props.userStore;
    const { isTablet, isPhone } = this.props.utilStore

    const currentLanguage = this.props.translationStore.locale

    const seesDetailLink = isLoggedIn || this.props.cookies.get('hasDetailAccess')

    const text = (key) => {
      return this.props.translationStore.getText(key)
    }

    return (
      <HeaderWrapper>
        <HeaderContent>
          <LogoWrapper onClick={() => this.props.history.push("/")}>
            <img
              alt="lint.."
              src={require('../../images/logo-menu.png')}
            />
          </LogoWrapper>
          { isPhone ? (
            <BurgerMenuButton onClick={ this.toggleMobileNavigation } open={this.state.mobileNavigationOpen}>
              <BurgerBar /><BurgerBar /><BurgerBar />
            </BurgerMenuButton>
          ) : (
            <LinkWrapper>
              <LanguageSwitcherWrapper>
                { AVAILABLE_LANGUAGES.map(item => <LanguageSwitcherItem onClick={() => {this.props.translationStore.setLanguage(item.code)}} className={ item.code === currentLanguage ? 'current' : '' }>{ item.name }</LanguageSwitcherItem>)}
              </LanguageSwitcherWrapper>
              {/* {seesDetailLink && <Link onClick={() => this.props.history.push("/details-zur-plattform")}>nähere Informationen</Link> } */}
              <Link onClick={() => this.props.history.push("/golfcourses")}>{ text('marketing_header_for_golfclubs') }</Link>
              <Link onClick={() => {this.props.history.push("/#pricing"); document.querySelector('#pricing').scrollIntoView()}}>{ text('marketing_header_price') }</Link>
              <Link onClick={() => this.props.history.push("/news")}>{ text('public_news') }</Link>
              {/* <Link onClick={() => this.props.history.push("/herbst-aktion")}>Herbstaktion</Link> */}
              {!isLoggedIn && <Link onClick={() => this.props.history.push("/login")}>{ text('login') }</Link> }
              {!isLoggedIn && <BoxedLink onClick={() => this.openRequestInformationModal() } > <Arrow size="1.2em" />{ text('marketing_header_request_information') }</BoxedLink> }
              {isLoggedIn && <BoxedLink onClick={() => this.props.history.push("/internal")}>{ text('marketing_header_member_area') }</BoxedLink> }
            </LinkWrapper>
          )}

        </HeaderContent>
        { isPhone &&
          <MobileNavigationWrapper visible={ this.state.mobileNavigationOpen }>
            <div>
              { isLoggedIn ?
                <MobileLink onClick={() => this.openMobileLink("/internal")}>{ text('marketing_header_member_area') }</MobileLink>
                : <MobileLink onClick={() => this.openMobileLink("/login")}>{ text('login') }</MobileLink> }

              {/* { seesDetailLink && <MobileLink onClick={() => this.openMobileLink("/details-zur-plattform")}>nähere Informationen</MobileLink> } */}
              <MobileLink onClick={() => this.openMobileLink("/golfcourses")}>{ text('marketing_header_for_golfclubs') }</MobileLink>
              <MobileLink onClick={() => {this.props.history.push("/#pricing"); document.querySelector('#pricing').scrollIntoView()}}>{ text('marketing_header_price') }</MobileLink>
              <MobileLink onClick={() => this.openMobileLink("/news")}>{ text('public_news') }</MobileLink>
              {/* <MobileLink onClick={() => this.openMobileLink("/herbst-aktion")}>Herbstaktion</MobileLink> */}

              <MobileNavigationSeperator />

              <MobileLink onClick={() => this.openMobileLink("/impressum")}>{ text('imprint') }</MobileLink>
              <MobileLink onClick={() => this.openMobileLink("/datenschutz")}>{ text('dataprivacy') }</MobileLink>

              <MobileNavigationSeperator />
              <MobileLink>
                <LanguageSwitcherWrapper>
                  { AVAILABLE_LANGUAGES.map(item => <LanguageSwitcherItem onClick={() => {this.props.translationStore.setLanguage(item.code)}} className={ item.code === currentLanguage ? 'current' : '' }>{ item.name }</LanguageSwitcherItem>)}
                </LanguageSwitcherWrapper>
              </MobileLink>
            </div>
          </MobileNavigationWrapper>
        }
        { isPhone && <CloseMobileNavigation open={ this.state.mobileNavigationOpen } onClick={ this.toggleMobileNavigation } onTouchStart={ this.toggleMobileNavigation } />}
      </HeaderWrapper>
    )
  }

}

export default withCookies(withRouter(MarketingHeader));


// const HeaderWrapper = styled(MaxContentWidthWrapper) `
const MobileNavigationWrapper = styled.div `
  position: absolute;
  top: ${ cssVar.headerHeight }px;
  background: ${ cssVar.colors.blue };
  width: 100%;
  z-index: 99;
  padding: 0 30px;
  transition: all ${ cssVar.transitions.basic };
  max-height: ${ props => props.visible ? '100vh' : '0px'};
  padding: ${ props => props.visible ? '30px' : '0 30px'};
  opacity: ${ props => props.visible ? '1' : '0.6'};
  overflow: hidden;
  text-align: center;
  border-top: ${ props => props.visible ? `1px solid ${ cssVar.colors.gold }` : `none` };
`

const LanguageSwitcherWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 10px;
`

const LanguageSwitcherItem = styled.div `
  display: inline-block;
  cursor: pointer;
  padding: 0 10px;
    text-underline-offset: 0.15em;

  &:not(:last-child) {
    border-right: 1px solid white;
  }

  &:hover {
    text-decoration: underline;
  }

  &.current {
    font-weight: bold;
    text-decoration: underline;
  }
`

const CloseMobileNavigation = styled.div `
  width: 100%;
  height: 100vh;
  z-index: -1;
  position: absolute;
  offset: 0;

  display: ${ props => props.open ? 'block' : 'none'};
`

const BurgerMenuButton = styled.div `
  width: 25px;
  height: 21px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  margin-right: 20px;

  > div {
    :nth-child(1) {
      ${ props => props.open ? `
        transform: rotate(45deg) translateY(-50%);
        top: 50%;
      ` : `
        top: 0;
      `}
    }
    :nth-child(2) {
      top: 50%;
      transform: translateY(-50%);
      width: ${ props => props.open ? 0 : '100%'};
    }
    :nth-child(3) {
        ${ props => props.open ? `
          transform: rotate(-45deg) translateY(50%);
          bottom: 50%;
        ` : `
          bottom: 0;
        `}
    }
  }
`

const BurgerBar = styled.div `
  position: absolute;
  width: 100%;
  height: 3px;
  background: white;
  transition: all ${ cssVar.transitions.basic };
  transform-origin: center;
`

const HeaderWrapper = styled.div `
  width: 100%;
  background: ${ cssVar.colors.blue };
  position: fixed;
  top: 0;
  z-index: 100;
`

// const HeaderContent = styled(MaxContentWidthContainer) `
const HeaderContent = styled.div `
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${ cssVar.headerHeight }px;
  background: ${ cssVar.colors.blue };
  z-index: 101;
`

const LogoWrapper = styled.div `
  margin: 20px;
  height: calc( 100% - 40px);
  cursor: pointer;

  img {
    height: 100%;
    width: auto;
  }
`

const LinkWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  text-transform: uppercase;


  font-family: 'Supreme-Medium';
  font-size: 16px;
  letter-spacing: 0.03em;
`

const Link = styled.div `
  padding: 20px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all ${ cssVar.transitions.basic };
  cursor: pointer;


  ${cssVar.breakpoints.phone} {
    ${ props => props.hideOnMobile && 'display: none;'}
  }

  :hover {
    text-decoration: underline;
    text-underline-offset: 5px;
  }
`

const MobileLink = styled.div `
  margin: 15px 0;
  width: 100%;
  text-align: center;
  font-size: 20px;
  opacity: 0.8;
  text-transform: uppercase;
  cursor: pointer;
  font-family: 'Supreme-Medium';
`

const MobileNavigationSeperator = styled.div `
  width: 30px;
  display: inline-block;
  margin: 15px 0;
  height: 2px;
  background: ${ cssVar.colors.gold };
  opacity: 0.6;
`

const BoxedLink = styled(Link) `
  background: ${ cssVar.colors.gold };
  color: ${ cssVar.colors.blue };

  :hover {
    background: ${ cssVar.colors.dark_gold };
    text-decoration: none;
  }
`



// WEBPACK FOOTER //
// /src/components/layout/MarketingHeader.js